module.exports = __webpack_public_path__ + "files/95b78d6938e8de09f3c6eb179782f0f9.png";